export const ADMIN_TABS = [];

export const PUBLIC_NAV_ITEMS = [
  { id: "orders", label: "Orders", icon: "📦" },
  { id: "customers", label: "Customers", icon: "👥" },
  { id: "analytics", label: "Analytics", icon: "📊" },
  { id: "table-bookings", label: "Table Bookings", icon: "🍽" },
  // { id: "easter-bookings", label: "Easter Buffet", icon: "🥚" },
  { id: "items", label: "Instock Items", icon: "📋" },
  { id: "outofstock", label: "Sold Out", icon: "⚠️" },
  { id: "categories", label: "Categories", icon: "🗂" },
  { id: "store-closures", label: "Store Closures", icon: "🚫" },
];

export const ADMIN_NAV_ITEMS = [];
